define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/action/Controller",
    "csi/comm/PostRequest"
], function(declare,lang,Controller,PostRequest) {

	return declare(Controller, {

	        process: function() {
	            // summary: issue request so as to be able to receive return value
	            var req = this.m_action.m_request;
	            var fd = this.m_formData;
	            this.setProgress();
	            new PostRequest(req.m_module, req.m_operation)
	                .addParameter("ParentURL", this.m_urlParent)
	                .addParameter("StyleSizeCharts",fd.getFieldValue("StyleSizeCharts"))
	                .addParameter("Dimensions", fd.getFieldValue("SizeChartDimensions"))
	                .addParameter("Option",fd.getFieldValue("Option"))
	                .addParameter("UpdateSizeChartProperties", true)
	                .post({}).then(lang.hitch(this, this._onPublishResponse));
	        }
	    });
	});